// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"69f138a6","137":"851a48b4","293":"72c0937e","358":"0f299ab2","419":"0b94cc9e","581":"8493f5c1","606":"43ae7044","621":"df5490c4","870":"f641996c"}[chunkId] + ".chunk.css";
};